exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Editor{position:absolute;top:120px;left:0;right:0;height:auto;background:#fff;padding:30px 0 75px;margin:auto;border-bottom:1px solid #fff}.Editor .Post{width:100%}.Editor .circle-picker{position:relative;width:100%!important;padding-top:15px!important;z-index:1000}.Editor .circle-picker div{margin:-.45%}.Editor .Editor__inputs{padding:30px}.Editor .Editor__inputs .Editor__inputs--nome{color:#000}.Editor .Editor__inputs input,.Editor .Editor__inputs textarea{color:#4c5a55;background-color:#f5f5f5!important;border:0;border-color:none;font-size:16px;padding:20px;box-shadow:none}.Editor .Editor__inputs label{color:#4c5a55;font-size:20px;padding:10px}.Editor .Editor__inputs .Editor__inputs--post{color:#000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Editor/Editor.less
 ** module id = 173
 ** module chunks = 0
 **/